import ControllerBase from '../../../../global/js/ControllerBase';

interface ComponentRefs {
	scrollLeftStag: 'scrollLeftStag';
	scrollRightStag: 'scrollRightStag';
}
export default class ControllerTeaserRowStaggered extends ControllerBase<ComponentRefs> {
	private readonly scrollLeftStagButton: HTMLSpanElement;
	private readonly scrollRightStagButton: HTMLSpanElement;

	constructor(element: HTMLElement) {
		super(element);
		this.scrollLeftStagButton = this.$references.scrollLeftStag as HTMLSpanElement;
		this.scrollRightStagButton = this.$references.scrollRightStag as HTMLSpanElement;

		this.scrollRightStagHandler();
		this.scrollLeftStagHandler();
	}

	private scrollRightStagHandler(): void {
		this.scrollRightStagButton && this.scrollRightStagButton.addEventListener('click', (e) => {
			e.preventDefault();
			const elementToScroll = this.$element.querySelector('.o-teaser-single-row-staggered__teasers');
			elementToScroll && elementToScroll.scrollTo(elementToScroll.scrollLeft + 440, 0);
			this.scrollLeftStagButton.classList.remove("disabled");
			
			if(elementToScroll && Math.abs(elementToScroll?.scrollLeft) === elementToScroll?.scrollWidth - elementToScroll?.clientWidth){
				this.scrollRightStagButton.classList.add("disabled");
			}
			
		});
	}

	private scrollLeftStagHandler(): void {
		this.scrollLeftStagButton && this.scrollLeftStagButton.addEventListener('click', (e) => {
			e.preventDefault();
			const elementToScroll = this.$element.querySelector('.o-teaser-single-row-staggered__teasers');
			elementToScroll && elementToScroll.scrollTo(elementToScroll.scrollLeft - 440, 0);
			this.scrollRightStagButton.classList.remove("disabled");
			
			if(elementToScroll && elementToScroll.scrollLeft <=440){
				this.scrollLeftStagButton.classList.add("disabled");
			}
		});
    }
}